<template>
  <v-container
    id="download"
    tag="section"
  >
    <v-row class="back">
      <v-col class="col-xs-2" md="2">
        <v-btn class="float-left" color="primary" @click="$router.back(-1)">
          <v-icon>apps</v-icon>
          {{ $t('global.goBack') }}
        </v-btn>
      </v-col>

      <div class="col-sm-12 col-md-2 col-lg-2" v-if="fileType === 'ppt'">
        <div class="download-filter-list">
          <v-select
            v-model="productType"
            :items="productTypes"
            item-text="name"
            item-value="tid"
            :label="$t('global.pleaseSelect')"
            return-object
            dense
            outlined
            @change="selectedChange(productType)"
          ></v-select>
        </div>
      </div>

      <div class="col-sm-12 col-md-2 col-lg-2" v-if="fileType === 'news'">
        <div class="download-filter-list">
          <v-select
            v-model="newsType"
            :items="newsTypes"
            item-text="name"
            item-value="tid"
            :label="$t('global.pleaseSelect')"
            return-object
            dense
            outlined
            @change="selectedChange(newsType)"
          ></v-select>
        </div>
      </div>

    </v-row>
    <v-col lg="12" md="12" sm="12">
      <v-alert
        :value="alert"
        :type="alertType"
        :class="alterClass"
        transition="scale-transition"
      >
        {{alertMessage}}
      </v-alert>
      <v-row dense :class="`${fileType}`">
        <template v-if="fileType === 'video'">
          <template v-for="(download, index) in downloadList">
            <template v-if="['mp4', 'wmv', 'avi'].includes(download.extension.toLowerCase())">
              <v-col
                md="4"
                sm="6"
                :key="index"
                cols="12"
              >
                <v-card
                  class="mx-auto"
                >
                  <div :class="{'video-cover': true, 'locked': (download.no_permisstion || download.need_login)}">
                    <img :src="download.field_video_cover ? download.field_video_cover : require('@/assets/download/default-video.jpg')" />
                    <a class="play-btn" @click="trackClickEvent(download, 'play')"></a>
                  </div>
                  <v-card-actions>
                    <a @click="trackClickEvent(download, 'play')">
                      <div>{{ download.title }}</div>
                    </a>
                  </v-card-actions>
                </v-card>
              </v-col>
            </template>
          </template>

          <v-card
            class="mx-auto download-list"
            width="100%"
          >
            <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" ref="infiniteLoading"
                              :distance="distance">
              <span slot="no-more">{{ $t('global.noMoreFiles') }}</span>
              <span slot="no-results">{{ $t('global.noMoreFiles') }}</span>
            </infinite-loading>
          </v-card>
        </template>

        <template v-else>
          <v-card
            class="mx-auto download-list"
            width="100%"
          >

            <v-list two-line :class="`${fileType}`">
              <template v-for="(download, index) in downloadList">
                <v-hover :key="index" v-slot:default="{ hover }">
                  <v-list-item targe :class="{'elevation-12': hover, 'locked': (download.no_permisstion || download.need_login)}">

                    <div v-if="download.extension.toLowerCase() === 'pdf'">
                      <v-list-item-avatar>
                        <v-icon color="secondary" class="material-icons-outlined">mdi-file-pdf</v-icon>
                      </v-list-item-avatar>
                    </div>

                    <div v-else-if="download.extension.toLowerCase() === 'txt'">
                      <v-list-item-avatar>
                        <v-icon color="secondary" class="material-icons-outlined">mdi-clipboard-text</v-icon>
                      </v-list-item-avatar>
                    </div>

                    <div
                      v-else-if="['png', 'jpg'].includes(download.extension.toLowerCase())">
                      <v-list-item-avatar>
                        <v-icon color="secondary" class="material-icons-outlined">photo_size_select_actual</v-icon>
                      </v-list-item-avatar>
                    </div>

                    <div
                      v-else-if="['doc', 'docx'].includes(download.extension.toLowerCase())">
                      <v-list-item-avatar>
                        <v-icon color="secondary" class="material-icons-outlined">mdi-file-word</v-icon>
                      </v-list-item-avatar>
                    </div>

                    <div
                      v-else-if="['ppt', 'pptx'].includes(download.extension.toLowerCase())">
                      <v-list-item-avatar>
                        <v-icon color="secondary" class="material-icons-outlined">mdi-file-powerpoint</v-icon>
                      </v-list-item-avatar>
                    </div>

                    <div
                      v-else-if="['xls', 'xlsx'].includes(download.extension.toLowerCase())">
                      <v-list-item-avatar>
                        <v-icon color="secondary" class="material-icons-outlined">mdi-file-excel</v-icon>
                      </v-list-item-avatar>
                    </div>

                    <!--                      <div-->
                    <!--                        v-else-if="['mp4', 'wmv'].includes(download.extension.toLowerCase())">-->
                    <!--                        <v-list-item-avatar>-->
                    <!--                          <v-icon color="secondary" class="material-icons-outlined">movie</v-icon>-->
                    <!--                        </v-list-item-avatar>-->
                    <!--                      </div>-->

                    <div v-else>
                      <v-list-item-avatar>
                        <v-icon color="secondary" class="material-icons-outlined">mdi-file-document</v-icon>
                      </v-list-item-avatar>
                    </div>


                    <div class="center-content">
                      <v-list-item-content>
                        <a @click="trackClickEvent(download, ['mp4', 'wmv'].includes(download.extension.toLowerCase()) ? 'play' : 'download')">
                          <v-list-item-title v-text="download.title"></v-list-item-title>
                        </a>
                      </v-list-item-content>

                      <v-list-item-content>
                        <v-list-item-title v-html="download.body"></v-list-item-title>
                      </v-list-item-content>
                    </div>

                    <v-list-item-content v-if="!isMobile">
                      <v-list-item-title class="right" v-text="download.filesize"></v-list-item-title>
                    </v-list-item-content>

                    <!--                      <v-list-item-action v-if="download.extension.toLowerCase() === 'mp4' || download.extension.toLowerCase() === 'wmv'">-->
                    <!--                        <a @click="trackClickEvent(download, 'play')">-->
                    <!--                          <v-btn icon>-->
                    <!--                            <v-icon>play_circle_outline</v-icon>-->
                    <!--                          </v-btn>-->
                    <!--                        </a>-->
                    <!--                      </v-list-item-action>-->

                    <v-list-item-action>

                      <a @click="trackClickEvent(download)">
                        <template v-if="download.no_permisstion || download.need_login">
                          <v-btn icon>
                            <v-icon class="material-icons-outlined">lock</v-icon>
                          </v-btn>
                        </template>

                        <template v-else>
                          <v-btn icon>
                            <v-icon>file_download</v-icon>
                          </v-btn>
                        </template>
                      </a>
                    </v-list-item-action>
                  </v-list-item>
                </v-hover>
                <v-divider
                  v-if="index + 1 < downloadList.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
            <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" ref="infiniteLoading"
                              :distance="distance">
              <span slot="no-more">{{ $t('global.noMoreFiles') }}</span>
              <span slot="no-results">{{ $t('global.noMoreFiles') }}</span>
            </infinite-loading>
          </v-card>
        </template>
      </v-row>
    </v-col>

    <v-dialog
      v-model="requestVideoDialog"
      transition="dialog-bottom-transition"
      persistent
      max-width="940px"
    >
      <v-card>
        <v-toolbar>
          <v-btn icon dark @click="closeRequestVideoDialog()">
            <v-icon color="black">close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
        <video-player :video-src="videoSrc"></video-player>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import {mapState} from 'vuex'
  import videoPlayer from '../components/VideoPlayer'
  import config from '../config'
  import {isMobile} from '../utils/globalUtils'
  const isDev = process.env.NODE_ENV !== 'production'
  // 每页显示的文章条数
  // const pageCount = isDev ? config.dev.pageCount : config.prod.pageCount
  const pageCount = 10
  export default {
    components: {videoPlayer},

    computed: {
      ...mapState({
        requestVideoDialog: state => state.core.requestVideoDialog,
        isLogin: state => state.user.isLogin
      }),
    },

    data() {
      return {
        distance: -Infinity,
        infiniteId: +new Date(),
        downloadList: [],
        productType: {
          name: this.$t('global.all'),
          tid: 'all'
        },
        productTypes: [
          {
            name: this.$t('global.all'),
            tid: 'all'
          },
          {
            name: this.$t('global.resins'),
            tid: 'resins'
          },
          {
            name: this.$t('global.additives'),
            tid: 'additives'
          }
        ],
        newsType: {
          name: this.$t('global.all'),
          tid: 'all'
        },
        newsTypes: [
          {
            name: this.$t('global.all'),
            tid: 'all'
          },
          {
            name: this.$t('downloadList.companyNews'),
            tid: 'cooperate_news'
          },
          {
            name: this.$t('downloadList.resins'),
            tid: 'resins_coatings'
          },
          {
            name: this.$t('downloadList.resins2'),
            tid: 'resins_printing'
          },
          {
            name: this.$t('downloadList.additives'),
            tid: 'additives'
          }
        ],
        alertMessage: '',
        alertType: '',
        alterClass: '',
        alert: false,
        videoSrc: '',
        fileType: '',
        isMobile: isMobile()
      }
    },

    created() {
      let query = this.$router.history.current.query;

      if (!this.isLogin && ['product_manual', 'ppt'].includes(query.file_type)) {
        this.$router.push({ path: '/download' });
      }
    },

    mounted() {
      let vm = this
      vm.distance = 1
      vm.changeFilter()
    },

    methods: {
      trackClickEvent(download, action = 'download') {
        let ceshi = true

        // console.log(!this.isLogin)
        if (!this.isLogin && download.need_login) {
          this.$store.commit("open_login_dialog")
        }
        else {
         if (download.no_permisstion) {
           this.setAlert('当前用户没有此文件的下载和查看权限，请在“联系我们”中联系管理员', 'warning')
         }
         else {
           if (download.file_exists) {
             // 如果文件是视频就弹出播放,否则就默认下载
             if (action === 'play') {
               const video = document.getElementById('heroVideoPopup')
               this.$store.state.core.requestVideoDialog = true
               this.videoSrc = download.file_url
               if (video) {
                 video.play()
               }
             } else {
               window.location.href = download.field_global_file
             }
           } else {
             this.setAlert('当前文件因为未知原因已经不存在，请在“联系我们”中联系管理员', 'error')
           }

           if (window.clab_tracker && window.clab_tracker.hasOwnProperty('push')) {
             window.clab_tracker.push({});
             window.clab_tracker.track("click_link_in_page", {});
           }
         }
        }
      },

      closeRequestVideoDialog() {
        const video = document.getElementById('heroVideoPopup')
        this.$store.state.core.requestVideoDialog = false
        video.pause()
      },

      changeFilter() {
        this.downloadList = []
        this.infiniteId += 1
      },

      infiniteHandler($state) {
        let vm = this
        let options = {}

        options.items_per_page = pageCount
        options.page = vm.downloadList.length / pageCount
        vm.fileType = options.field_file_type = vm.$route.query.file_type

        if (vm.fileType === 'ppt' && vm.productType.tid !== 'all') {
          options.field_product_type = vm.productType.tid
        }

        if (vm.fileType === 'news' && vm.newsType.tid !== 'all') {
          options.field_news_type = vm.newsType.tid
        }

        vm.$store.dispatch('getDownloadList', options).then((res) => {
          let downloads = vm.$store.state.download.downloadList

          if (res.hasOwnProperty('response') && res.response.status === 401) {
            vm.setAlert('您当前没有权限查看下载文件，请注册并登录账户~查看自己权限', 'warning')
          }
          if (downloads.length) {
            vm.downloadList = vm.downloadList.concat(downloads)

            $state.loaded()
            if (downloads.length < pageCount) {
              $state.complete()
            }
          } else {
            $state.complete()
          }
        }).catch(err => {
          console.log(err)
        })
      },

      setAlert(message, style, type) {
        type === 'append'
          ? (this.alertMessage += message)
          : (this.alertMessage = message)
        this.alertType = style
        this.alterClass = 'bounce-enter-active'
        this.alert = true
        this.scrollTop()
        setTimeout(() => {
          this.clearAlert()
        }, 5000)
      },

      clearAlert() {
        let vm = this
        vm.alterClass = 'bounce-leave-active'
        setTimeout(() => {
          vm.alert = false
          vm.alertMessage = ''
          vm.alertType = ''
        }, 1200)
      },

      scrollTop: function () {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },

      selectedChange() {
        let vm = this

        vm.changeFilter();
      }
    }
  }
</script>
<style lang="scss" scoped>
  #download {
    max-width: 1318px;

    .download-list {

      .v-list {
        padding: 0;
        border-bottom: 1px solid #ddd;

        .v-avatar {

          i {
            height: 40px;
            width: 40px;
            margin-top: 0;
          }
        }

        .v-list-item {

          &.locked {
            background-color: rgba(226, 213, 213, 0.32);
            color: #655c5c !important;
          }
        }

        .center-content {
          align-items: center;
          align-self: center;
          display: flex;
          flex-wrap: wrap;
          flex: 6;
          overflow: hidden;
          padding: 12px 0;


          .v-list-item__content {

             &:first-child {
               flex: 2;
             }
          }
          .v-list-item__title {
            ::v-deep {
              p {
                margin-bottom: 0;
              }
            }
          }

          @media screen and (max-width: 768px) {
            flex-direction: column;

            .v-list-item__content {
              display: block;
              width: 100%;
              padding: 0;
            }
          }
        }
      }
    }

    .infinite-loading-container {
      height: 72px;
      line-height: 72px;
    }

    .right {
      text-align: right;
    }

    .video {
      display: flex;
      flex-wrap: wrap;

      & > .col-md-4 {

        .v-card {
          height: 100%;
        }
      }

      .video-cover {
        position: relative;
        height: 85%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .play-btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0,0,0,.2);
          background-image: url('../assets/download/play-button.png');
          background-position: center center;
          background-size: 70px 70px;
          background-repeat: no-repeat;
        }

        .video-title {
          position: absolute;
          bottom: 15px;
          left: 20px;
          color: #fff;
          font-size: 16px;
        }

        &.locked {
          .play-btn {
            background-color: rgba(0,0,0,.2);
            background-image: url('../assets/download/unlock.png');
          }
        }
      }
    }
  }
</style>
